import {IBaseModel, BaseModel} from "../base.model";


export interface IDocument extends IBaseModel {
  type?: number;
  typeLvl2?: number;
  name?: string;
  attachments?: any[];
  blocks?: number[];
  apartments?: number[];
  share?: string[];
  entities?: number[];
  equipments?: number[];
  all_block?:boolean;
  sharing_role?:number[];
}


export class DocumentDto extends BaseModel implements IDocument {
  type?: number
  typeLvl2?: number
  name?: string
  attachments?: any[]
  blocks?: number[]
  apartments?: number[]
  share?: string[]
  entities?: number[]
  equipments?: number[]
  all_block?:boolean
  sharing_role?:number[];

  constructor(opts: IDocument) {
    super(opts)
    //this.share= []
    if (!opts.share) this.share = []
    if (!opts.typeLvl2) this.typeLvl2 = null
    if (!opts.all_block) this.all_block = false
    if (!opts.sharing_role) this.sharing_role = []
  }
}



// WEBPACK FOOTER //
// ./src/models/documents/document.ts